import * as React from "react";
import {Default} from "./Layouts/Desktop/Default";
import {Sidebar} from "./Layouts/Desktop/Sidebar";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import "./Megamenu.scss";
import useHeaderMenuStore from "@src/stores/HeaderMenuStore";

export const Megamenu = ({ settings, menuItems, id, state }) =>
{
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

    const { currentMenu } = useHeaderMenuStore();

    if (state !== id) {
        return null;
    }

    const layout = isMobile ? settings.section.layout_mobile : settings.section.layout;
    const LayoutComponent = Layouts[layout];

    return (
        <LayoutComponent
            settings={settings}
            menuItems={menuItems}
            layout={layout}
            id={id}
            state={state}
        />
    );
};

const Layouts = {
    "default": Default,
    "sidebar": Sidebar,
};
